import appResources from "./src/AppResources";
import Engine from "@milestoneslabs/milestones-js-engine";

Engine.config({
    appResources: appResources
});

export {
    Engine
}
